import { render, staticRenderFns } from "./MyMorakhasiList.vue?vue&type=template&id=30bb860f&"
import script from "./MyMorakhasiList.vue?vue&type=script&lang=js&"
export * from "./MyMorakhasiList.vue?vue&type=script&lang=js&"
import style0 from "./MyMorakhasiList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports